import { render, staticRenderFns } from "./BulkActionsContactsModal.vue?vue&type=template&id=03151e90&scoped=true&lang=pug"
import script from "./BulkActionsContactsModal.vue?vue&type=script&lang=js"
export * from "./BulkActionsContactsModal.vue?vue&type=script&lang=js"
import style0 from "./BulkActionsContactsModal.vue?vue&type=style&index=0&id=03151e90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03151e90",
  null
  
)

export default component.exports